import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.3.1_@types+node@18.15.7_eslint@8.36.0_optionator@0.9.4_rollup@3.18.0_sass@1.60.0_c7790f775ef7ee098c2326bd893577f4/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}